"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const path = __importStar(require("path"));
const dist_1 = require("../../../fs/dist");
const runEvent_1 = require("../../../app/dist/runEvent");
exports.toolDef = {
    name: 'loom_start_plan',
    description: 'Transition a plan to status "implementing". Call only on plans with status "draft" or "active". Use this tool to start a plan — do not edit plan files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            planId: { type: 'string', description: 'Plan id. Canonical form is the ULID (e.g. "pl_01J…"); the filename stem (e.g. "my-weave-plan-001") is also accepted and resolved.' },
        },
        required: ['planId'],
    },
};
async function handle(root, args) {
    const planKey = args['planId'];
    // Resolve filename-stems / typos to the canonical plan id (with suggest-on-miss),
    // then derive the weave from the resolved path.
    const { id: planId, filePath } = await (0, dist_1.resolveDocIdOrThrow)(root, planKey);
    const weaveId = path.relative(path.join(root, 'loom'), filePath).split(path.sep)[0];
    const loadWeaveStrict = async (r, w) => {
        const result = await (0, dist_1.loadWeave)(r, w);
        if (!result)
            throw new Error(`Weave not found: ${w}`);
        return result;
    };
    const deps = { loadWeave: loadWeaveStrict, saveDocs: dist_1.saveDocs, loomRoot: root };
    const updatedWeave = await (0, runEvent_1.runEvent)(weaveId, { type: 'START_IMPLEMENTING_PLAN', planId }, deps);
    const plan = updatedWeave.threads.flatMap(t => t.plans).find(p => p.id === planId);
    return { content: [{ type: 'text', text: JSON.stringify({ planId, status: plan?.status ?? 'implementing' }) }] };
}
